import { ButtonsWrapper } from './ButtonsContainer.styled';
import { FlatButton } from 'ui/buttons';
import { Box } from '@mui/material';

interface IButtonsContainer {
  titleButton: string;
  onClick: () => void;
  onClickBack?: () => void;
  top?: string;
  right?: string;
  bottom?: string;
  left?: string;
  position?: string;
}

const ButtonsContainer = ({
  titleButton,
  top,
  right,
  left,
  bottom,
  position,
  onClick,
  onClickBack,
}: IButtonsContainer) => {
  const handleClick = () => {
    onClick && onClick();
  };

  const handleClickBack = () => {
    onClickBack && onClickBack();
  };

  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent={position ? position : 'flex-end'}
      width="100%"
    >
      <ButtonsWrapper top={top} right={right} bottom={bottom} left={left}>
        <FlatButton onClick={handleClickBack}>Back</FlatButton>
        <FlatButton variant="contained" onClick={handleClick}>
          {titleButton}
        </FlatButton>
      </ButtonsWrapper>
    </Box>
  );
};

export default ButtonsContainer;
